export function noopReducer<State>(): (state: State) => State;
export function noopReducer<State, Defaults = State>(defaults: Defaults): (state: State | Defaults) => State | Defaults;

export function noopReducer(defaults = null) {
  return (state = defaults) => state;
}
